import type { WebappResponse } from '@eventbrite/event-listing-service-client';
import { CreatorCollectionsLink } from './CreatorCollectionsLink';

export const CreatorCollections = ({ collections }: { collections: WebappResponse['collections'] }) => {
  return <CreatorCollectionsLink collections={collections} />;
};
